import React from "react";
import { View, Text } from "@react-pdf/renderer";

const scanOrder = (styles: React.CSSProperties | any): JSX.Element => (
    <View style={styles.scanTxt}>
        <Text>Scan to Order</Text>
    </View>
);
export default scanOrder;
